// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package20: FC<Package20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M9.25 16.063v-5.625L4.5 7.688v5.625l4.75 2.75Zm1.5 0 4.75-2.73V7.708l-4.75 2.73v5.624Zm-1.5 1.75-5.5-3.188A1.457 1.457 0 0 1 3 13.333V6.667a1.457 1.457 0 0 1 .75-1.292l5.5-3.188a1.454 1.454 0 0 1 1.5 0l5.5 3.188A1.456 1.456 0 0 1 17 6.667v6.666a1.456 1.456 0 0 1-.75 1.292l-5.5 3.188a1.454 1.454 0 0 1-1.5 0Zm3.917-10.521 1.729-.98L9.979 3.5l-1.666.98 4.854 2.812ZM10 9.125l1.708-.98-4.937-2.79-1.667.957L10 9.125Z" />
        </svg>
    );
};

export default Package20;
